import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "device-run",
  "use": "device-run-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"device-run\"><path d=\"M12.5 8a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0zM14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0zm-3.875.217a.25.25 0 0 0 0-.434l-3-1.732a.25.25 0 0 0-.375.217v3.464a.25.25 0 0 0 .375.217l3-1.732z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol